import React, { useContext, useState, useEffect, useMemo } from 'react';
import {
  Widget,
  FormSelect,
  SimpleView,
  MasterDetailForm,
  GridView,
  Row,
  InlineEditTable,
  InlineEditColumnProps,
  Table,
  FormText,
  Button,
  FormInput,
} from '@digital/ui';
import { SelectValue } from 'antd/lib/select';
import { hasPermission } from '@app/helpers/permissions';
import { Collapse, Icon, Input } from 'antd';
import { RequisitadoComOrdemCompra } from '@app/api/projeto';

interface FormResumoCapexProps {
  requisitoComOrdemCompra: RequisitadoComOrdemCompra[];
  projetoId: string;
  style: any;
}

const { Panel } = Collapse;

const FormTableRequisitadoCompraOrdemCompraProjeto = (props: FormResumoCapexProps) => {
  const { requisitoComOrdemCompra, projetoId, style } = props;

  const [valorTotal, setValorTotal] = useState<string>();

  useEffect(() => {
    const getData = () => {
      if (requisitoComOrdemCompra.length > 0) {
        var requisitado = requisitoComOrdemCompra[requisitoComOrdemCompra.length - 1];
        if (requisitado) {
          setValorTotal(requisitado.distribuidoTotalFormatado);
        } else {
          setValorTotal('');
        }
      } else {
        setValorTotal('');
      }
    };

    getData();
  }, [requisitoComOrdemCompra]);

  const customColumns = () => {
    return [
      {
        title: 'N',
        dataIndex: 'index',
        width: '1%',
      },
      {
        title: 'RC',
        dataIndex: 'requisicaoCompraNumero',
        width: '2%',
      },
      {
        title: 'RC Seq',
        dataIndex: 'requisicaoCompraSeq',
        width: '1%',
      },
      {
        title: 'Principal',
        dataIndex: 'principalFormatado',
        width: '1%',
      },
      {
        title: 'Narrativa',
        dataIndex: 'narrativa',
        width: '35%',
      },
      {
        title: 'Valor total',
        dataIndex: 'requisicaoCompraValorTotalFormatado',
        width: '5%',
      },
      {
        title: 'No Projeto',
        dataIndex: 'valorDistribuidoFormatado',
        key: 'valorTotalCurrency',
        children: [
          {
            title: `${valorTotal || ''}`,
            dataIndex: 'valorDistribuidoFormatado',
            width: '1%',
          },
        ],
      },
      {
        title: 'Valor à distribuir',
        dataIndex: 'valorParaDistribuidoFormatado',
        width: '1%',
      },
      {
        title: 'OC',
        dataIndex: 'requisicaoCompraOc',
        width: '5%',
      },
    ] as InlineEditColumnProps<RequisitadoComOrdemCompra>[];
  };

  return (
    <>
      <Collapse
        bordered={false}
        defaultActiveKey={['2']}
        expandIcon={() => <Icon type="arrows-right_4" />}
        style={style}>
        <Panel key="2" header="ITENS DE REQUISIÇÃO DE COMPRA COM ORDEM DE COMPRA" style={{ border: 0 }}>
          <MasterDetailForm>
            <Widget
              actions={[
                projetoId && (
                  <Button
                    title="Distribuir Requisitado(Com OC)"
                    type="primary"
                    icon="commons-search"
                    onClick={() => {
                      window.location.href = `/requisitadoOcordemcompra`;
                    }}
                  />
                ),
              ]}>
              <Row>
                <Table rowKey="index" columns={customColumns()} dataSource={requisitoComOrdemCompra} />
              </Row>
            </Widget>
          </MasterDetailForm>
        </Panel>
      </Collapse>
    </>
  );
};

export default FormTableRequisitadoCompraOrdemCompraProjeto;
